import { useEffect } from 'react'
import { Helmet } from 'react-helmet'
import { useNavigate } from 'react-router-dom'
import {
  selectBrand,
  selectContent,
  selectCustomer,
  selectCustomerHouseAccounts,
  fetchCustomerHouseAccounts,
  useAppDispatch,
  useAppSelector,
} from '@open-tender/cloud'
import {
  Content,
  HeaderUser,
  Loading,
  Main,
  PageContainer,
  PageContent,
  PageError,
  PageTitle,
} from 'components'
import HouseAccountsList from './HouseAccountsList'

const AccountHouseAccounts = () => {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const { title: siteTitle, has_house_accounts } =
    useAppSelector(selectBrand) || {}
  const { auth } = useAppSelector(selectCustomer)
  const { houseAccounts: config } = useAppSelector(selectContent) || {}
  const { entities, loading, error } = useAppSelector(
    selectCustomerHouseAccounts
  )
  const isLoading = loading === 'pending'

  useEffect(() => {
    if (!auth || !has_house_accounts) return navigate('/account')
  }, [auth, has_house_accounts, navigate])

  useEffect(() => {
    dispatch(fetchCustomerHouseAccounts())
  }, [dispatch])

  return (
    <>
      <Helmet>
        <title>
          {config?.title} | {siteTitle}
        </title>
      </Helmet>
      <Content>
        <HeaderUser />
        <Main>
          <PageContainer style={{ maxWidth: '76.8rem' }}>
            <PageTitle {...config} />
            <PageError error={error} />
            {entities.length ? (
              <HouseAccountsList houseAccounts={entities} />
            ) : (
              <PageContent>
                {isLoading ? (
                  <Loading text="Retrieving your house accounts..." />
                ) : (
                  <p>
                    Looks like your account isn't currently associated with any
                    house accounts.
                  </p>
                )}
              </PageContent>
            )}
          </PageContainer>
        </Main>
      </Content>
    </>
  )
}

export default AccountHouseAccounts
